import { AuthProvider, useAuth } from "./providers/authProvider";
import { DataProvider } from "./providers/dataProvider";
import { LoginScreen } from "./components/LoginScreen";
import { Dashboard } from "./components/Dashboard";

const Router = () => {
  const { auth } = useAuth();
  if (auth.status === "loading") {
    return <div className="min-h-screen" />;
  }
  if (auth.status === "loggedOut") {
    return <LoginScreen />;
  }
  return (
    <DataProvider>
      <Dashboard />
    </DataProvider>
  );
};

export const App = () => (
  <AuthProvider>
    <Router />
  </AuthProvider>
);
